const GallerySkeleton = () => (
  <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4">
    {Array.from({ length: 9 }).map((_, i) => (
      <div
        key={i}
        className="aspect-square rounded-xl bg-muted animate-pulse"
      />
    ))}
  </div>
);

export default GallerySkeleton;
